import { useFormValidatedValue } from 'modules/taboola-common-frontend-modules/validations';
import { useBidValidations } from './useBidValidations';

export const useFormBidValidatedValue = ({ pricingModel }) => {
    const validations = useBidValidations(pricingModel);
    return useFormValidatedValue(validations);
};
